import { render } from "./Conclusion.vue?vue&type=template&id=cf8bfa86&scoped=true"
import script from "./Conclusion.vue?vue&type=script&lang=js"
export * from "./Conclusion.vue?vue&type=script&lang=js"

import "./Conclusion.vue?vue&type=style&index=0&id=cf8bfa86&lang=scss&scoped=true"

import exportComponent from "/Users/malik/Sites/ismatgroup-satisfaction/front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf8bfa86"]])

export default __exports__